import React from "react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { ScrollView } from "devextreme-react";
import { LoadIndicator } from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import api from "../../api-axios";
import ShowError from "../../AppServices";

export default class AdnNfeXmlPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      carregando: false,
      xml: null,
      mensagemNaoEncontrado: null,
    };
    this.copiarXml = this.copiarXml.bind(this);
    this.fechar = this.fechar.bind(this);
    this.onShown = this.onShown.bind(this);
    this.onHiding = this.onHiding.bind(this);
  }

  onShown() {
    this.carregarXml();
  }

  carregarXml() {
    const { prefeituraId, nsu } = this.props;

    if (prefeituraId === undefined || nsu === undefined) {
      return;
    }

    this.setState({
      carregando: true,
      xml: null,
      mensagemNaoEncontrado: null,
    });

    api
      .get(`adn-scrap/${prefeituraId}/${nsu}`, { responseType: "text" })
      .then((response) => {
        this.setState({ carregando: false, xml: response.data });
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          this.setState({
            carregando: false,
            mensagemNaoEncontrado: "XML não encontrado no armazenamento.",
          });
        } else {
          this.setState({ carregando: false });
          ShowError(error.response ? error.response.data : error.message);
        }
      });
  }

  copiarXml() {
    navigator.clipboard.writeText(this.state.xml || "");
    notify("XML copiado.", "success");
  }

  onHiding() {
    this.setState({
      carregando: false,
      xml: null,
      mensagemNaoEncontrado: null,
    });

    if (this.props.onHiding) {
      this.props.onHiding();
    }
  }

  fechar() {
    this.onHiding();
  }

  render() {
    const { visible, chaveAcesso } = this.props;
    const { carregando, xml, mensagemNaoEncontrado } = this.state;

    return (
      <Popup
        visible={visible}
        onHiding={this.onHiding}
        onShown={this.onShown}
        dragEnabled={false}
        closeOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        width={"80%"}
        height={"80%"}
        title={"XML da NFS-e " + chaveAcesso}
      >
        <ScrollView width="100%" height="100%">
          <div>
            {carregando && (
              <div style={{ textAlign: "center", marginTop: "40px" }}>
                <LoadIndicator width={60} height={60} />
              </div>
            )}
            {!carregando && mensagemNaoEncontrado && (
              <div style={{ textAlign: "center", marginTop: "40px" }}>
                {mensagemNaoEncontrado}
              </div>
            )}
            {!carregando && xml && (
              <pre
                style={{
                  fontFamily:
                    "Consolas, 'Courier New', monospace",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {xml}
              </pre>
            )}
          </div>

        </ScrollView>
        <ToolbarItem
          toolbar={"bottom"}
          widget="dxButton"
          location="center"
          options={{
            text: "Copiar XML",
            disabled: !xml,
            onClick: this.copiarXml,
          }}
        />
        <ToolbarItem
          toolbar={"bottom"}
          widget="dxButton"
          location="center"
          options={{
            text: "Fechar",
            onClick: this.fechar,
          }}
        />
      </Popup>
    );
  }
}
